import API from "serviceshift-ui/api-client";

export default {
  clearJob({ commit }) {
    commit("replace", {
      state: "job",
      data: {}
    });
  },
  createJob(_, { link, payload }) {
    const { href, method } = link;
    return API.makeRequest(href, {
      method,
      data: payload
    });
  },
  async fetchJob({ commit }, { jobId }) {
    const res = await API.makeRequest(`/v2/jobs/${jobId}`, {
      method: "GET",
      params: {
        item_grouping: 1
      }
    });
    commit("replace", {
      state: "job",
      data: res.data
    });
    return res;
  },
  fetchOpportunityStatuses(_, { jobId }) {
    return API.makeRequest(`/v2/jobs/${jobId}/opportunity_statuses`, {
      method: "GET"
    });
  },
  fetchJobLinkedCalls(_, { jobId }) {
    return API.makeRequest(`/v2/jobs/${jobId}/linked_calls`, {
      method: "GET"
    });
  },
  setJobOpportunity(_, { jobId, ...data }) {
    return API.makeRequest(`/v2/jobs/${jobId}`, {
      method: "PUT",
      data,
      params: { item_grouping: 1 }
    });
  },
  setMembershipOpportunity(_, { url, ...data }) {
    return API.makeRequest(url, {
      method: "PUT",
      data
    });
  },
  setJobCommissions(_, { jobId, commissions }) {
    return API.job.setJobCommissions(jobId, commissions);
  },
  updateJobDepartment(_, { jobId, ...data }) {
    return API.makeRequest(`/v2/jobs/${jobId}`, {
      method: "PUT",
      data,
      params: { item_grouping: 1 }
    });
  },
  updateJob(_, { jobId, ...data }) {
    return API.makeRequest(`/v2/jobs/${jobId}`, {
      method: "PUT",
      data,
      params: { item_grouping: 1 }
    });
  },
  previewDepartmentChange(_, { jobId, departmentId }) {
    return API.makeRequest(
      `/v2/jobs/${jobId}/preview_department_change/${departmentId}`,
      {
        method: "GET"
      }
    );
  },
  updateJobLeadType({ commit }, params) {
    return API.makeRequest(`/v2/jobs/${params.jobId}/lead`, {
      method: "PUT",
      data: {
        job: params.lead
      },
      params: { item_grouping: 1 }
    }).then((res) => {
      if (!params.tableMode) {
        commit("replace", {
          state: "job",
          data: res.data
        });
      }
    });
  },
  breakJobSignature(_, { action_url, reason }) {
    return API.makeRequest(action_url, {
      method: "PUT",
      data: {
        reason
      }
    });
  }
};
